import { Box, Flex } from '@chakra-ui/react';

import { UserIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';
import useGetActiveOperators from 'Domain/monitoring/useGetActiveOperators';
import { TextBold, TextRegular } from 'UiKit/typography';

import EmptyActiveOperators from 'View/monitoring/component/empty-active-operators';
import ActiveOperatorsSkeleton from 'View/monitoring/component/skeleton/active-operators-skeleton';
import BadgeOperatorStatus from 'View/monitoring/component/badge-operator-status';

import styles from './styles.module.css';

const ActiveOperators = ({ t }) => {
  const { data, isFetching } = useGetActiveOperators();

  return (
    <Condition statement={!isFetching} fallback={<ActiveOperatorsSkeleton />}>
      <Box className={styles['active-operators__container']}>
        <TextBold className={styles['active-operators__title']}>{t('activeOperatorsView.title')}</TextBold>
        <Box className={`${styles['active-operators__list--container']} ${!data?.length && styles['active-operators__empty--container']}`}>
          <Condition statement={data?.length && !isFetching} fallback={<EmptyActiveOperators />}>
            <Iteration
              items={data}
              render={(item, index) => {
                return (
                  <Box key={index} className={styles['active-operators__card']} data-testid="active-operators__card">
                    <Box className={styles['active-operators__card--user']}>
                      <UserIcon color="var(--color-semantic-white)" width="20px" height="20px" />
                    </Box>
                    <Box>
                      <TextRegular className={styles['active-operators__operator--name']}>{item.name}</TextRegular>
                      <Flex gap={'8px'} alignItems={'center'}>
                        <TextRegular className={styles['active-operators__operator--shift']}>
                          {item.shiftName} ({item.shiftTimeRange})
                        </TextRegular>
                        <BadgeOperatorStatus status={item?.status} />
                      </Flex>
                    </Box>
                  </Box>
                );
              }}
            />
          </Condition>
        </Box>
      </Box>
    </Condition>
  );
};

export default ActiveOperators;
